exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listino-cliente[data-v-481b5b87]{padding:2em;position:relative;min-height:50px}", ""]);

// exports
